<template>
  <div class="tag">
    <div class="sales item">
      <span class="num">{{props.currency}}{{props.totalParams.totalAmount}}</span>
      <span class="name">Total Amount</span>
    </div>
    <div class="seller item">
      <span class="num">{{props.currency}}{{props.totalParams?.totalPaidAmount}}</span>
      <span class="name">Paid</span>
    </div>
    <div class="publishers item">
      <span class="num">{{props.currency}}{{(props.totalParams?.totalNotPaidAmount || 0).toFixed(2)}}</span>
      <span class="name">Not Paid</span>
    </div>
    <div class="publishers item">
      <span class="num">{{props.currency}}{{(props.totalParams?.totalDeclinedAmount || 0).toFixed(2)}}</span>
      <span class="name">Not Applicable</span>
    </div>
  </div>
</template>
<script setup>
  const props = defineProps(['totalParams', 'currency']);
</script>
<style lang="less" scoped>
  .tag {
    display: flex;
    margin-top: 16px;
    .item {
      background: #F8F7FC;
      display: flex;
      flex-direction: column;
      padding: 7px 12px;
      color: var(--dark-1);
      text-align: center;
      width: 180px;
      margin-right: 20px;
      border-radius: 12px;
      .num {
        font-weight: 600;
        font-size: 20px;
        line-height: 24px;
      }
      .name {
        font-size: 12px;
        color: var(--dark-2);
        font-weight: 600;
        margin-top: 4px;
      }
      .filter {
        font-size: 12px;
        color: var(--dark-3);
      }
    }
  }
</style>